import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/App";
import EhiLogOutcomeModal from "./EhiLogOutcomeModal";

export const demoClientId = (d) => d?.client_id || (String(d?.lead_id || "").startsWith("ehi-") ? String(d.lead_id).slice(4) : null);

/** EHI client Log Outcome for a client demo: saves the outcome, then marks the demo completed / no-show. */
export default function EhiDemoOutcomeModal({ demo, token, onClose, onSaved }) {
  const [saving, setSaving] = useState(false);
  const cid = demoClientId(demo);
  const name = demo.company || demo.lead_title || `Client ${cid}`;
  const save = async (d) => {
    const h = { headers: { Authorization: `Bearer ${token}` } };
    setSaving(true);
    try {
      const r = await axios.post(`${API}/ehi-clients/${cid}/outcomes`, { ...d, for_demo_booking_id: demo.id }, h);
      const status = d.contact_status === "Connected" ? "completed" : "no_show";
      try {
        if (!["completed", "no_show"].includes(demo.status)) {
          await (status === "completed"
            ? axios.post(`${API}/demo-bookings/${demo.id}/complete`, { outcome_notes: d.notes || "" }, h)
            : axios.post(`${API}/demo-bookings/${demo.id}/no-show`, {}, h));
        }
        toast.success(r.data.outcome?.task_id ? "Outcome saved — follow-up task added to Tasks" : "Outcome saved");
      } catch {
        toast.warning("Outcome saved, but the demo status couldn't be updated — refresh and check it");
      }
      onSaved?.(status);
    } catch (e) {
      const det = e?.response?.data?.detail;
      toast.error(typeof det === "string" ? det : "Couldn't save the outcome");
    } finally { setSaving(false); }
  };
  return (
    <EhiLogOutcomeModal client={{ client_id: cid, clinic: name, phone: demo.phone, email: demo.email }}
      clientName={name} clientId={cid} saving={saving} onClose={onClose} onSave={save} />
  );
}
